import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';

import { SendInsurancePayload, SendedLaSegundaResponse } from './la-segunda-confirmation.types';

type Config = { type: 'lasegunda' | 'galicia' | 'fedpatronal' | 'swissre' };

// deprecated service ref.: postLaSegundaInsurance_DEPRECATED
export async function confirmLaSegundaService({ body }: SendInsurancePayload, config: Config) {
  const ENDPOINT_MAP = {
    lasegunda: ENDPOINT.INSURANCE_LASEGUNDA,
    galicia: ENDPOINT.INSURANCE_GALICIA,
    fedpatronal: ENDPOINT.INSURANCE_FED_PATRONAL,
    swissre: ENDPOINT.INSURANCE_SWISS_RE,
  };

  const { response, data } = await BACKEND.post<SendedLaSegundaResponse>(ENDPOINT_MAP[config.type], {
    body,
  });

  return {
    response,
    summary: data,
  };
}
